<!-- Hero Section -->
<section class="delete-hero">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <h1 class="hero-title">SAFROO</h1>
    <p class="hero-subtitle">Account Deletion Guide</p>
  </div>
</section>

<!-- Content Section -->
<section class="delete-content-section">
  <div class="delete-container">
    <div class="intro-section">
      <h2 class="main-title">How to Delete Your Account</h2>
      <p class="intro-text">
        We're sorry to see you go. If you've decided to delete your Safroo account, 
        please follow these simple steps. Once your account is deleted, all your data 
        will be permanently removed from our system. This action cannot be undone.
      </p>
    </div>

    <!-- Step 1 -->
    <div class="step-card">
      <div class="step-content">
        <div class="step-number">Step 1</div>
        <h3 class="step-title">Login to Your Account</h3>
        <p class="step-description">
          Open the Safroo app on your mobile device and log in using your registered 
          email address and password. Make sure you're using the correct credentials 
          associated with the account you wish to delete. If you've forgotten your 
          password, use the "Forgot Password" option to reset it before proceeding.
        </p>
      </div>
      <div class="step-image">
        <img src="assets/DeleteAccount/image1.png" alt="Login Screen" />
      </div>
    </div>

    <!-- Step 2 -->
    <div class="step-card reverse">
      <div class="step-image">
        <img src="assets/DeleteAccount/image2.png" alt="Settings Screen" />
      </div>
      <div class="step-content">
        <div class="step-number">Step 2</div>
        <h3 class="step-title">Navigate to Settings</h3>
        <p class="step-description">
          After successfully logging in, locate and tap on the "Settings" icon, 
          typically found in the bottom navigation bar or in the menu. The Settings 
          page contains all your account preferences and management options. Here 
          you'll find various options to customize your experience and manage your 
          account details.
        </p>
      </div>
    </div>

    <!-- Step 3 -->
    <div class="step-card">
      <div class="step-content">
        <div class="step-number">Step 3</div>
        <h3 class="step-title">Deactivate Your Account</h3>
        <p class="step-description">
          In the Settings menu, scroll down to find the "Deactivate Account" option. 
          Tap on it to proceed. A confirmation dialog will appear asking you to confirm 
          your decision. This is your last chance to reconsider. Once you click "Yes" 
          on the confirmation dialog, your account will be permanently deleted along 
          with all your personal data, booking history, and preferences. This action 
          is irreversible and cannot be undone.
        </p>
        <div class="warning-box">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <div>
            <strong>Warning:</strong> This action is permanent and cannot be reversed. 
            All your data will be permanently deleted.
          </div>
        </div>
      </div>
      <div class="step-image">
        <img src="assets/DeleteAccount/image3.png" alt="Deactivate Account Screen" />
      </div>
    </div>

    <!-- Help Section -->
    <div class="help-section">
      <h3 class="help-title">Need Help?</h3>
      <p class="help-text">
        If you're experiencing any issues or have questions about deleting your account, 
        our support team is here to help. You can reach us through:
      </p>
      <div class="help-options">
        <div class="help-option">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <span>info@safroo.com</span>
        </div>
        <div class="help-option">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <span>+971 56 330 6574</span>
        </div>
      </div>
    </div>
  </div>
</section>
